import { DEFAULT_LOCALE } from '@/constants';
import { getLocaleUrlPath } from '@/utils/i18n';

export const getBreadcrumbsFullURL = (path, index) =>
  `${
    index === 0 ? 'https://minfin.com.ua' : process.env.APP_DEPLOY_URL
  }${path}${path?.endsWith('/') ? '' : '/'}`;
export const getMainPageUrl = () => `${process.env.APP_ROUTER_BASENAME}/`;
export const getOrganizationUrl = (org) =>
  `${process.env.APP_ROUTER_BASENAME}/${org}-b/`;
export const geProductUrl = ({ org, currency, slug, id }) =>
  `${process.env.APP_ROUTER_BASENAME}/${id}-${currency}-${slug}-in-${org}/`;
export const getProductPageAbsolutUrl = ({
  locale = DEFAULT_LOCALE,
  org,
  currency,
  slug,
  id,
}) =>
  `${process.env.APP_DEPLOY_URL}${getLocaleUrlPath(locale)}${process.env.APP_ROUTER_BASENAME}/${id}-${currency}-${slug}-in-${org}/`;
export const getReviewPageUrl = ({ locale = DEFAULT_LOCALE, companySlug }) =>
  `https://minfin.com.ua${getLocaleUrlPath(
    locale
  )}/company/${companySlug}/review/add/`;

// Api
export const getBreadcrumbsApiRequestUrl = ({
  pathname,
  locale = DEFAULT_LOCALE,
}) =>
  `${process.env.APP_MINFIN_API_DOMAIN}/api/breadcrumbs/?url=${pathname}&locale=${locale}`;
export const getContentUrl = ({ locale = DEFAULT_LOCALE, url }) =>
  `${process.env.APP_CONTENT_API_ROOT}${locale}?url=${url}&project=minfin-credits-business`;
export const getProductApiRequestUrl = ({
  locale = DEFAULT_LOCALE,
  id,
  categorySlug,
}) =>
  `${process.env.APP_MINFIN_API_DOMAIN}/api/invest/v2/offer/${categorySlug}/${id}/uah/?locale=${locale}`;
export const getCitiesListRequestApiUrl = () =>
  `${process.env.APP_MINFIN_API_DOMAIN}/api/cities/`;

export const getCurrencyRatesRequestApiApi = ({ currency }) =>
  `${process.env.APP_MINFIN_API_DOMAIN}/api/currency/rates/nbu/${currency}/avg/`;
export const getCurrencyRatesApiRequestUrl = ({ currency = 'usd' }) =>
  `${process.env.APP_DEPLOY_URL}${process.env.APP_ROUTER_BASENAME}//api/currencyRates?currency=${currency}`;
export const getOrgListApiRequestUrl = ({ locale = DEFAULT_LOCALE }) =>
  `${process.env.APP_DEPLOY_URL}${process.env.APP_ROUTER_BASENAME}/api/organizationsList?locale=${locale}`;
export const getCitiesListApiRequestUrl = ({ locale = DEFAULT_LOCALE }) =>
  `${process.env.APP_DEPLOY_URL}${process.env.APP_ROUTER_BASENAME}/api/citiesList?locale=${locale}`;
export const getOrgV2RequestUrl = ({ locale = DEFAULT_LOCALE, slug }) =>
  `${process.env.APP_MINFIN_API_DOMAIN}/api/v2/company/${slug}/?locale=${locale}`;

// NEW
export const getIconSpriteUrl = (iconId) =>
  `${process.env.APP_DEPLOY_URL}${process.env.APP_ASSETS_PUBLIC_PATH}sprite.${process.env.APP_VERSION}.svg#${iconId}`;
export const getOrganizationsListApiRequestUrl = ({
  locale = DEFAULT_LOCALE,
}) =>
  `${process.env.APP_MINFIN_API_DOMAIN}/api/company/list/?type[]=bank&locale=${locale}`;
export const getProductsIdsApiRequestUrl = ({
  filters = '',
  additionalFilters = '',
}) =>
  `${process.env.APP_PRODUCTS_API_ROOT}/grouped_list?product_type=15&active=1${additionalFilters}${filters}`;
export const getProductsListApiRequestUrl = ({ locale, ids }) =>
  `${process.env.APP_PRODUCTS_API_ROOT}/data?locale=${locale}&ids=${ids}`;
